import { ArrowLeft } from 'lucide-react';
import { ReactNode } from 'react';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { CloseIcon } from '@shared/ui/CloseIcon';

import { changeStep, closeAuthModal } from '../../../model/slice/authSlice';
import cls from './Wrap.module.scss';

type WrapProps = {
  title: string;
  children: ReactNode;
  back?: boolean;
};

export const Wrap = ({ title, children, back }: WrapProps) => {
  const dispatch = useAppDispatch();
  const prevStep = useAppSelector((state) => state.auth.prevStep);

  const closeModalHandler = () => {
    dispatch(closeAuthModal());
  };

  const goBack = () => {
    dispatch(changeStep(prevStep));
  };

  return (
    <div className={cls.wrap}>
      <div className={cls.top}>
        <div className={cls.block}>
          {back && (
            <button
              className={cls.back}
              onClick={goBack}
            >
              <ArrowLeft size={18} />
            </button>
          )}
          <div className={cls.title}>{title}</div>
        </div>

        <CloseIcon
          className={cls.close}
          onClick={closeModalHandler}
        />
      </div>

      {children}
    </div>
  );
};
